import { FormControl, FormControlLabel, Radio, RadioGroup, Stack, Typography } from '@mui/material';
import { ControllerFieldState, ControllerRenderProps } from 'react-hook-form';
import { FieldPath } from 'react-hook-form/dist/types';
import { ReactNode } from 'react';

interface EnableDisableRadioGroupProps<T, U extends FieldPath<T>> {
    title: string;
    field: ControllerRenderProps<T, U>;
    fieldState: ControllerFieldState;
    onChange: (enabled: boolean) => void;
    testId: string;
    enableLabel?: string;
    enableChild?: ReactNode;
    disableLabel?: string;
    disableChild?: ReactNode;
}

export const EnableDisableRadioGroupFormControl = <T, U extends FieldPath<T>>({
    title,
    field,
    fieldState,
    onChange,
    testId,
    enableLabel = 'Enable',
    enableChild,
    disableLabel = 'Disable',
    disableChild,
}: EnableDisableRadioGroupProps<T, U>) => {
    return (
        <FormControl fullWidth error={fieldState.invalid}>
            <Typography>{title}</Typography>
            <RadioGroup
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...field}
                value={JSON.stringify(field.value)}
                onChange={(event) => onChange(event.target.value === 'true')}
            >
                <Stack direction="row" justifyContent="flex-start" alignItems="stretch" width="100%">
                    <FormControlLabel
                        value={true}
                        control={<Radio data-testid={`${testId}-enable`} />}
                        label={enableLabel}
                        sx={{ flex: 1 }}
                    />
                    {field.value === true && enableChild}
                </Stack>
                <Stack direction="row" justifyContent="flex-start" alignItems="stretch" width="100%">
                    <FormControlLabel
                        value={false}
                        control={<Radio data-testid={`${testId}-disable`} />}
                        label={disableLabel}
                    />
                    {field.value === false && disableChild}
                </Stack>
            </RadioGroup>
        </FormControl>
    );
};
